export const sxConfig = {
  containerBox: {
    height: { xs: 'auto', md: '92%', lg: '93%' },
    bgcolor: 'grey.100',
  },
  formBox: {
    p: 1,
    backgroundColor: (theme) => theme.palette.common.white,
    overflow: 'auto',
    boxShadow: 1,
    borderRadius: 2,
    height: { xs: 'auto', md: '100%' },
  },
  fromWarehouseCheck: {
    mt: '-0.5rem',
  },
  checkBox: {
    m: 0,
    mr: 0.5,
    p: 0,
  },
  checkBoxMainBox: {
    display: 'flex',
  },
  richTreeView: {
    minHeight: 210,
    minWidth: 250,
    p: 1,
  },
};
